<template>
  <div class="sfile">
    <div class="sfile_input">
      <div class="sfile_input_icon">
        <font-awesome-icon :icon="['fas', 'download']" />
      </div>
      <input
        ref="inputfile"
        :name="name"
        :id="id"
        :accept="accept"
        @change="init($event)"
        type="file"
        multiple
        data-multiple-caption="{count} файлов выбрано"
      >
      <label :for="id">{{ labelInline }}</label>
    </div>
    <div class="sfile_notice">
      <p>{{ notice }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SFile',
  props: {
    id: String,
    name: String,
    label: String,
    notice: String,
    accept: {
      type: String,
      default: 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  },
  data () {
    return {
      labelInline: '',
      files: '',
    }
  },
  created () {
    this.labelInline = this.label
  },
  methods: {
    init ($e) {
      let fileName = ''

      if ($e.target.files && $e.target.files.length > 1) {
        fileName = ($e.target.getAttribute('data-multiple-caption') || '').replace('{count}', $e.target.files.length)
        this.files = $e.target.files
      } else {
        fileName = $e.target.value.split('\\').pop()
        this.files = $e.target.value
      }

      if (fileName) { this.labelInline = fileName } else {
        this.labelInline = this.label
        this.files = ''
      }

      this.$emit('input', this.files)
    },
  },
}
</script>

<style lang="less">
.sfile {
	width: 100%;
	display: flex;
	flex-direction: column;

	&_input {
		display: flex;
		margin-bottom: 17px;
		position: relative;
		cursor: pointer;

		&_icon {
			flex-shrink: 0;
			margin-right: 15px;

			svg {
				font-size: 15px;
				color: #003CFF;
			}
		}

		input {
			width: 0.1px;
			height: 0.1px;
			opacity: 0;
			overflow: hidden;
			position: absolute;
			z-index: -1;

			& + label {
				font-family: 'Roboto', Arial, sans-serif;
				font-weight: 300;
				font-size: 14px;
				color: #003CFF;
				border-bottom: 1px dashed #003CFF;
				cursor: pointer;

				* { pointer-events: none; }
			}
		}
	}

	&_notice {
		p {
			font-family: 'Roboto', Arial, sans-serif;
			font-weight: 300;
			font-size: 12px;
			color: #AFAFAF;
			line-height: 18px;
		}
	}
}
</style>
